export default __webpack_public_path__ + "static/media/feather _ menu.20fc5ede.svg";